import { StackFrame } from "@sentry/solidstart";

import Analytics from "@repo/utils/Analytics";
import UObject from "@repo/utils/UObject";
import Platform from "@repo/utils-client/Platform";
import AppRouter from "@repo/utils-solid/AppRouter";

import { useUser } from "~/state/features/user.js";

type Events = {
  conversion: {};
  analytics: {
    "view page":
      | {
          initial: true;
        }
      | {
          initial: false;
          from: string;
        };
    "sentry: send": {
      message: string | undefined;
      filestack: (string | undefined)[] | undefined;
      frames: UObject.Resolve<StackFrame>[] | undefined;
      suppress: boolean;
    };
  };
  other: {
    // Not meant to be populated
  };
};

const base = new Analytics<
  Events,
  {
    user: ReturnType<typeof useUser>[0];
  }
>();

export declare namespace Registration {
  type Analytics = Analytics.Client.Registration.Sync<typeof base, "analytics">;
  type Conversion = Analytics.Client.Registration.Sync<
    typeof base,
    "conversion"
  >;
  type Other = Analytics.Client.Registration.Sync<typeof base, "other">;
}

const clients =
  // prettier-ignore
  import.meta.glob("./clients/*/*.ts", {
  eager: true,
  import: "default",
}) as {
/* GENERATED */ "./clients/analytics/clarity.ts": typeof import("./clients/analytics/clarity.ts")["default"],
/* GENERATED */ "./clients/other/sentry.ts": typeof import("./clients/other/sentry.ts")["default"]
};

const analytics = !Platform.isClient
  ? (base as never)
  : base
      .setBaseProperties(() => ({
        // We cannot always guarantee analytics.track won't be called before
        // AppRouter is registered.
        path: AppRouter.registered
          ? AppRouter.pathname
          : window.location.pathname,
        "user agent": window.navigator.userAgent,
      }))
      .addClients(UObject.trimKeys(clients, "./clients/", ".ts"));

export default analytics;
export const track = analytics.track.bind(analytics);
